<script>
  import { getContext } from 'svelte'
  import Container from '~/components/ui/container.svelte'

  const page = getContext('work_page')
</script>

<section>
  <Container>
    <h2 class="title | mb-8 text-center text-4xl font-medium lg:text-5xl">
      {page.workPage.subtitle}
    </h2>

    <div class="flex flex-col gap-4 lg:flex-row lg:gap-0">
      <div class="grow border-gray-200 lg:w-[70%] lg:border-r lg:px-8">
        <figure>
          <img class="w-full" src={page.work.gallery[0].url} alt={page.work.gallery[0].alt} />
        </figure>
      </div>
      <div class="lg:w-[30%] lg:px-8">
        <div class="content | row | mb-4 gap-3 px-2">
          <div class="customer | center | size-[32px] flex-shrink-0 rounded-full bg-gray-200">
            <img
              class="size-[24px] rounded-full"
              width="24"
              height="24"
              src={page.work.customer.image.url}
              alt={page.work.customer.image.alt}
            />
          </div>

          <div class="information">
            <h3 class="text-lg font-medium">{page.work.title}</h3>
            <p class="text-md text-gray-600">
              {page.work.description}
            </p>
          </div>
        </div>

        <!-- {#if page.work.gallery}
					<div class="row row-wrap | -mx-2 w-full">
						{#each page.work.gallery as galleryItem}
							<div class="w-[33.33%] cursor-pointer">
								<figure class="m-1 rounded-xl bg-gray-200 p-1">
									<img
										class="cover-top h-[72px] w-full rounded-lg"
										width="48"
										height="48"
										src={galleryItem.image.url}
										alt={galleryItem.image.alt}
									/>
								</figure>
							</div>
						{/each}
					</div>
				{/if} -->
      </div>
    </div>
  </Container>
</section>
